import HttpService from "@/services/http.service";

export default class CoreService extends HttpService {
    /**
     * Getter base API url
     * @returns {string}
     */
    get baseURL() {
        return '';
    }
}